import { render, staticRenderFns } from "./ForgetPwd.vue?vue&type=template&id=2ef65a38&scoped=true&"
import script from "./ForgetPwd.vue?vue&type=script&lang=js&"
export * from "./ForgetPwd.vue?vue&type=script&lang=js&"
import style0 from "./ForgetPwd.vue?vue&type=style&index=0&id=2ef65a38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef65a38",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ef65a38')) {
      api.createRecord('2ef65a38', component.options)
    } else {
      api.reload('2ef65a38', component.options)
    }
    module.hot.accept("./ForgetPwd.vue?vue&type=template&id=2ef65a38&scoped=true&", function () {
      api.rerender('2ef65a38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/account/ForgetPwd.vue"
export default component.exports